export const HEALTH_STATUS_TYPES = {
  healthy: 'healthy',
  degraded: 'degraded',
  unhealthy: 'unhealthy',
};

export interface HealthStatus {
  status: 'healthy' | 'degraded' | 'unhealthy';
  message: string | null;
  updatedAt: string;
}
